import { render, staticRenderFns } from "./CookieConsentModal.vue?vue&type=template&id=ac252fa8&scoped=true&"
import script from "./CookieConsentModal.vue?vue&type=script&lang=ts&"
export * from "./CookieConsentModal.vue?vue&type=script&lang=ts&"
import style0 from "./CookieConsentModal.vue?vue&type=style&index=0&id=ac252fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac252fa8",
  null
  
)

export default component.exports